(function (ws) {
    'use strict';
    ws.views.orderslips = ws.views.simpleTable.extend({

        /**
         * Initialize override
         */
        events: _.extend({}, ws.views.simpleTable.prototype.events, {
            'keyup .tbl-simple-searchInput': 'toggleDisable',
            'click .tbl-magnifying': 'triggerSearch',
            'click #clearFilterBtn': 'clearSearch',
            'change .tbl-simple-start-date': 'diableGoButton',
            'change .tbl-simple-end-date': 'diableGoButton',
            'change select#tbl-simple-page-size': 'doResetPageNumber',
            'click .viewCarrierTrackingButton': 'handleCarrierTrackingButtonEvent',
            'click .viewCarrierTrackingButtonPdf': 'handleCarrierTrackingPdfButtonEvent',
            'click .trackingLink': 'adobeCarrierTracking'
        }),

        initialize: function () {
            const westconApi = globals.path.api.westcon;
            this.$table = $('#packing-slip-table');
            this.paginateUrl = westconApi.packingSlipSearchUrl;
            this.searchUrl = westconApi.packingSlipSearchUrl;
            this.rowTemplate = $('#packing-slip-table-row');
            this.overrideFilterRequest = true;
            this.customErrorMessage = this.$('.custom-error-message');
            this.$invalidPoError = this.$('.invalid-po');
            this.$invalidSalesOrderError = this.$('.invalid-sales-order');
            this.$invalidConsigmentError = this.$('.invalid-consigment');
            this.$noResultPoError = this.$('.noresult-po');
            this.$noResultSalesOrderError = this.$('.noresult-salesorder');
            this.$noResultConsigmentError = this.$('.noresult-consigment');
            this.$invalidCarrierTrackingNoError = this.$('.invalid-carrier-tracking-no');
            this.$invalidSalesOrderError = this.$('.invalid-sales-order');
            this.$invalidConsigmentError = this.$('.invalid-consigment');
            this.$noResultPoError = this.$('.noresult-po');
            this.$noResultSalesOrderError = this.$('.noresult-salesorder');
            this.$noResultConsigmentError = this.$('.noresult-consigment');
            this.$noResultConsigmentDateError = this.$('.noresult-consigment-date');
            this.$quoteFilterHeader = this.$('.qut-filter-header p');
            this.$inputValue = this.$('.tbl-simple-searchInput');
            this.$startDate = $('#tbl-simple-start-date');
            this.$endDate = $('#tbl-simple-end-date');
            this.$aplyFilterbtn = $('#applyFilterBtn');
            this.$onLoadErrorCheck = $('.show-consignment-date-error');
            this.$currentPageValue = $('.currentPageValue');
            this.multiViewEnabled = this.$('#multiViewEnabled').val();

            ws.views.simpleTable.prototype.initialize.call(this);
            $(this.el).off('change', 'select#tbl-simple-am');
            $(this.el).off('change', 'select#tbl-simple-select');
            $(this.el).off('keypress', '.tbl-simple-searchInput');

            this.toggleDisable();

            this.searchCategory = 'packing slips';
            this.dhlStatus();
        },

        /**
         * Fires analytics event when user clicks on carrier tracking button
         */
        handleCarrierTrackingButtonEvent () {
            this.gtmEventTracking(this.GTM_EVENT_CARRIER_TRACKING_CATEGORY, this.GTM_EVENT_ACTION_CARRIER_TRACKING);
            _satellite.track('event:order:carrierTracking');
        },

        dhlStatus: function () {
            const arr = [];
            let ele = $('.viewCarrierTrackingButton');
            let apiCallRequired = false;
            for (let i = 0; i < ele.length; i++) {
                let elements = ele[i];
                if ($('#carriersForApiCall').val().includes($(elements).data('carriertype').toUpperCase())) {
                    let obj = {carrier: $(elements).data('carriertype'),
                        orderNumber: $(elements).data('salesordernumber'),
                        trackingNumber: $(elements).data('carrierTrackingNum').toString()};
                    arr.push(obj);
                    apiCallRequired = true;
                } else {
                    let obj = {carrier: $(elements).data('carriertype'),
                        orderNumber: '',
                        trackingNumber: $(elements).data('carrierTrackingNum').toString()};
                    arr.push(obj);
                }
            }

            if (apiCallRequired) {
                globals.disableApp();
                $.ajax({
                    url: `${sitePath}/pod/tracking/status?${CSRF}`,
                    contentType: 'application/json',
                    data: JSON.stringify({tracking: arr}),
                    method: 'POST'
                }).done(res => {
                    globals.enableApp();
                    if (res.length) {
                        res.forEach((item, i) => {
                            if (!item.status || item.status === 'Shipment Not Found') {
                                $(ele[i]).removeAttr('data-event');
                                $(ele[i]).html('');
                                $(`<span>${item.trackingNumber}</span>`).insertAfter(ele[i]);
                            } else {
                                if ($(ele[i]).data('salesordernumber') === item.orderNumber && item.status === 'Delivered' && $('#carriersForApiCall').val().includes(item.carrier.toUpperCase())) {
                                    console.log('Comment added to remove gulp warnings');
                                } else if ($('#carriersForApiCall').val().includes(item.carrier.toUpperCase()) && item.status) {
                                    $(ele[i]).removeAttr('data-event');
                                    $(ele[i]).html('');
                                    $(`<span>${item.trackingNumber}-In Processing</span>`).insertAfter(ele[i]);
                                }
                            }
                        });
                    } else {
                        for (let i = 0; i < ele.length; i++) {
                            let trackingNumber = $(ele[i]).data('carrier-tracking-num');
                            $(ele[i]).removeAttr('data-event');
                            $(ele[i]).html('');
                            $(`<span>${trackingNumber}</span>`).insertAfter(ele[i]);
                        }
                    }
                }).fail(function (response) {
                    globals.enableApp();
                    console.error(response);
                }.bind(this));
            }
        },

        /**
         * Fires analytics event when user clicks on carrier tracking pdf
         */
        handleCarrierTrackingPdfButtonEvent () {
            this.gtmEventTracking(this.GTM_EVENT_CARRIER_TRACKING_CATEGORY, this.GTM_EVENT_ACTION_PDF_CARRIER_TRACKING);
            _satellite.track('event:order:carrierTracking');

        },

        /**
         * Trigger Search
         */
        triggerSearch: function () {
            var disabled = $.trim(this.$inputValue.val()).length === 0;
            if (!disabled) {
                this.searchFilter();
            }
        },

        /**
         * Overriding the Page number to default Paginate function
         */
        doResetPageNumber: function () {
            this.$currentPageValue.val('0');
            this.searchFilter();
        },

        /**
         * Overriding the parent Paginate function
         * @param {Object} e
         */
        paginate: function (e) {
            e.preventDefault();
            this.$currentPageValue.val($(e.currentTarget).attr('href').substring(6));
            this.searchFilter();
        },

        /**
         * Before Trigger Search based on date filters disabling the go button
         */
        diableGoButton: function () {
            this.$aplyFilterbtn.prop('disabled', true);
        },

        render: function () {
            this.initializePikaday();
            this.endPicker.pikaday('setMinDate', this.$startDateInput.val());
            this.endPicker.pikaday('setMaxDate', new Date());
            ws.views.simpleTable.prototype.render.call(this);

            if (this.$startDateInput.val() != null) {
                $('.comp-simple-table-clear-filter-btn').show();
            }

            if (this.$onLoadErrorCheck.val() === 'Yes') {
                this.$noResultConsigmentDateError.show();
            }
        },

        /**
         * check value of search input and disable/enable button accordingly
         */
        toggleDisable: function(e) {
            const disabled = $.trim(this.$inputValue.val()).length === 0;

            if (((this.$inputValue.val()).length != 0) || (this.$startDateInput.val() != null)) {
                this.$quoteFilterHeader.show();
                this.$currentPageValue.val('0');
            }

            this.$aplyFilterbtn.toggleClass('disabled', disabled);
            this.$aplyFilterbtn.prop('disabled', disabled);

            if (e != undefined) {
                if (e.currentTarget.id === 'clearFilterBtn') {
                    $('.tbl-simple-header').hide();
                    $('.tbl-simple-page').hide();
                    this.$currentPageValue.val('0');
                }
            }

            //13 enter key code
            if (!disabled && (typeof e !== 'undefined' && e.which === 13)) {
                this.searchFilter();
            }
        },

        clearSearch: function (e) {
            e.preventDefault();

            this.$clearFilterButton.hide();
            this.$('.message-link').show();

            //strip out the standard filters since these should not be affected by a filter reset
            let filtersToClear = _.filter(this.filterDefaultVals, function (num) {
                return $('#' + num.id).parents('.tbl-simple-filters').length <= 1;
            }, 0);

            $(filtersToClear).each(function () {
                let $currEl = $('#' + this.id);
                $currEl.val(this.value);
                if ($currEl.is('select')) {
                    $currEl.trigger('change.select2');
                }
            });

            // clear all inputs
            this.$tableSimpleFilters.find('input:not(.unclear)').val('');

            //reset error messages for Date Range
            this.$startDateInput.removeClass('error');
            this.$endDateInput.removeClass('error');
            this.$startDueDateInput.removeClass('error');
            this.$endDueDateInput.removeClass('error');
            this.$dateDueError.hide();
            this.$validDueDateError.hide();
            this.$dateError.hide();
            this.$validDateError.hide();
            this.$('.error-message').hide();

            //reset error messages for Price Range
            this.$priceInputLower.removeClass('error');
            this.$priceInputUpper.removeClass('error');
            this.$priceerror.hide();

            this.$pageSizeInput.val(this.pageSizeDefault);
            this.$pageSizeInput.trigger('change.select2');

            this.$salesOrgValue.val('');
            this.$salesOrgValue.trigger('change.select2');

            $(this.$clearSelectElement).each(function () {
                $(this).val('').trigger('change.select2');
            });

            // reset sortCode
            this.sortCode = '';

            this.$table.dataTable().fnClearTable();
            this.$table.DataTable().destroy();

            // clear Pikaday
            this.resetPikaday();

            this.$tableSpinner.show();
            this.$emtpyTableCopy.hide();
            this.searchFilter();
            this.resetSortColumns();
            this.diableGoButton();
        },

        /**
         * Call Search Filter API
         * @param {Object} request
         */
        searchFilterCall: function (request) {
            this.model.set(request);
            this.model.url = this.searchUrl;
            if (request.pageSize || request.page) {
                this.model.url = this.searchUrl + '?page=' + request.page + '&pageSize=' + request.pageSize;
            }

            this.$table.dataTable().fnClearTable();
            this.$table.dataTable().fnDestroy();
            this.$table.DataTable().destroy();
            this.$('.error-message').hide();

            this.$tableSpinner.show();
            this.$emtpyTableCopy.hide();

            $.each(this.$tableHeaders, function (i, th) {
                $(th).removeClass('loaded');
            });

            $('.tbl-simple-header').hide();
            $('.tbl-simple-page').hide();
            this.enableDelaySpinner();
            this.model.save().done(function (data) {
                if (data.results.length === 0) {
                    this.handleEmptyErrorMessage();
                    this.$tableSpinner.hide();
                    this.disabledDelaySpinner();
                    this.$quoteFilterHeader.hide();
                    this.toggleApplySearchBtn(true);
                } else {
                    if (!_.isUndefined(data.results[0].error) && data.results[0].error !== null) {
                        this.showErrorMessage(data.results[0].error);
                        this.$tableSpinner.hide();
                        this.disabledDelaySpinner();
                        this.toggleApplySearchBtn(true);
                        this.$quoteFilterHeader.hide();
                    } else {
                        this.$tableSpinner.hide();
                        this.disabledDelaySpinner();
                        this.renderRows(data.results);
                        this.calculateShowing(data.pagination);
                        this.calculatePagination(data.pagination);
                        this.$pagination.addClass('search');
                        $('.tbl-simple-header').show();
                        $('.tbl-simple-page').show();
                        this.$clearFilterButton.toggle(true);
                        this.toggleApplySearchBtn(true);
                        this.customErrorMessage.hide();
                        this.$quoteFilterHeader.show();
                        this.dhlStatus();
                    }
                }
            }.bind(this)).fail(function () {
                this.disabledDelaySpinner();
                this.tableGenericError();
            }.bind(this));
        },

        /**
         * Overiding the Render a table row from the parent
         * @param {Object} result
         */
        renderRows: function (result) {
            var options;
            var _this = this;
            _.each(result, function (row) {
                row.multiViewEnabled = _this.multiViewEnabled;

                options = {
                    model: row,
                    rowTemplate: _this.rowTemplate
                };
                var tableRow = new ws.views.simpleTableRows(options);
                _this.$table.append(tableRow.render().el);
            });

            this.fadeInRows();
            this.initializeDataTable();

            if (this.sortColumn) {
                this.$table.find('th[data-attr=' + this.sortColumn + ']').addClass('sorting_' + this.sortCode);
            }
        },

        /**
         * Handle empty error messages depends on filter selected
         */
        handleEmptyErrorMessage () {
            switch (this.searchType.val()) {
                case 'sapOrderId':
                    this.$noResultSalesOrderError.show();
                    break;
                case 'purchaseOrderId':
                    this.$noResultPoError.show();
                    break;
                case 'code':
                    this.$noResultConsigmentError.show();
                    break;
            }
        },

        /**
         * Show error message coming from BE
         */
        showErrorMessage(errorMessage) {
            switch (errorMessage) {
                case 'packingslip.invalid.po':
                    this.$invalidPoError.show();
                    break;
                case 'packingslip.invalid.carriertrackingno':
                    this.$invalidCarrierTrackingNoError.show();
                    break;
                case 'packingslip.invalid.salesorder':
                    this.$invalidSalesOrderError.show();
                    break;
                case 'packingslip.invalid.consignment':
                    this.$invalidConsigmentError.show();
                    break;
                case 'packingslip.noresult.po':
                    this.$noResultPoError.show();
                    break;
                case 'packingslip.noresult.salesorder':
                    this.$noResultSalesOrderError.show();
                    break;
                case 'packingslip.noresult.consignment':
                    this.$noResultConsigmentError.show();
                    break;
                case 'packingslip.invalid.consignmentdate':
                    this.$noResultConsigmentDateError.show();
                    break;
                case 'packingslip.noresult.consignmentdate':
                    this.$noResultConsigmentDateError.show();
                    break;
                default:
                    this.customErrorMessage.show();
                    this.customErrorMessage.text(errorMessage);
            }
        },

        /**
         * Override filter request object
         */
        customFilterRequest: function () {
            const request = {};
            request.salesOrder = this.searchType.val() === 'sapOrderId' ? this.$searchInput.val() : '';
            request.poNumber = this.searchType.val() === 'purchaseOrderId' ? this.$searchInput.val() : '';
            request.packingSlip = this.searchType.val() === 'code' ? this.$searchInput.val() : '';
            request.carrierTrackingNo = this.searchType.val() === 'trackingNo' ? this.$searchInput.val() : '';
            request.fromDate = this.$startDate.val();
            request.toDate = this.$endDate.val();
            request.pageSize = Number($('#tbl-simple-page-size').val());
            request.page = Number(this.$currentPageValue.val());
            request.sortCode = this.sortColumn;
            request.sortOrder = this.sortCode;
            return request;
        },

        /**
         * Attach click events to all revision anchor triggers
         * @param {Object} row - Table row element
         */
        rowCallback: function (row) {
            $(row).find('[data-quote-code]').on('click', function (ev) {
                ev.preventDefault();

                this.eventAgg.trigger('openRevisionModal');

                new ws.views.quoteRevisionsTable({
                    quoteCode: $(ev.currentTarget).data('quote-code')
                });
            }.bind(this));
        },

        disableFutureDate: true,

        adobeCarrierTracking: function (e) {
            e.preventDefault();
            _satellite.track('event:order:carrierTracking');
            window.open($(e.target).attr('href'), '_blank');
        }
    });
})(westcon);
